module.exports = __webpack_public_path__ + "img/logo2.0.feb73090.png";